import { expensesAcceptedFileUploaderTypes } from 'utils/constants';
import useExpensesFilesUploadStore from './useExpensesFilesUploadStore';
import { CustomDropzoneConfig } from 'hooks/useCustomDropzoneStore';
import useDomainDropzoneStore from 'hooks/useDomainDropzoneStore';

const useExpensesDropzone = (config: CustomDropzoneConfig) => {
  const storeAPI = useExpensesFilesUploadStore();
  return useDomainDropzoneStore(
    config,
    storeAPI,
    expensesAcceptedFileUploaderTypes,
  );
};

const useDryExpensesDropzone = (config: CustomDropzoneConfig) => {
  const dryStoreAPI = useExpensesFilesUploadStore.getState();
  return useDomainDropzoneStore(
    config,
    dryStoreAPI,
    expensesAcceptedFileUploaderTypes,
  );
};

export { useExpensesDropzone, useDryExpensesDropzone };
